import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QmLoaderService } from '@md2/md2-component-lib';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor{

  spinCount: number = 0; 
  urlBlackList: string[] = ['api/v3/pbi', 'assets', 'jwks', 'openid-configuration'];

  constructor( public loaderService : QmLoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    
    if (this.urlBlackList.some(url => req.url.includes(url))) {
      return next.handle(req);
    } else {
        this.spinCount++;
        console.log('Mostrando loader, spinCount:', this.spinCount);
        this.loaderService.show();
    }

    return next.handle(req)
    .pipe( finalize(() => {
      if (!this.urlBlackList.some(url => req.url.includes(url))) {
        this.spinCount--;
        if (this.spinCount === 0) {
          console.log('Escondendo loader após 500ms');
          setTimeout(() => {this.loaderService.hide()}, 500)
        }
      }
    }));
    
  }

}